import React, { useMemo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../redux/slices/auth/useAuth';
import { getFirebaseApp } from '../utils/firebase'
import { getAuth } from 'firebase/auth';
import LoadingPage from '../pages/LoadingPage';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isLyfshortLoggedIn, isLoggedIn, loading } = useAuth();
  const auth = getAuth(getFirebaseApp())
  const location = useLocation();
  const title = 'Loading'

  if (loading) {
    return <LoadingPage title={title}/>
  }

  if (!loading && (!isLoggedIn || !isLyfshortLoggedIn || !auth.currentUser)) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }


  return <>{children}</>;
};

export default ProtectedRoute;
